import { render, staticRenderFns } from "./h-sponsor-list.vue?vue&type=template&id=09bc47cd&"
import script from "./h-sponsor-list.vue?vue&type=script&lang=js&"
export * from "./h-sponsor-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports